define((require) => {
    "use strict";

    const Backbone       = require("backbone");
    const _              = require("underscore");
    const EditorEvents   = require("shared/services/EditorEvents");
    const ImprovedView   = require("editor/zbone/ImprovedView");
    const ShareMenu      = require("ui/share/ShareMenu");
    const ShareViewModel = require("ui/share/ShareViewModel");
    const Tooltip        = require("ui/common/Tooltip");

    const ShareState = {
        HOVER_BEFORE_SHARING: 0,
        PICKING_RECIPIENT: 1,
        AFTER_SHARING: 2
    };

    const OverlayView = Backbone.View.extend({

        className: "share-overlay",

        events: {
            "activate": "_activateHandler"
        },

        render() {
            if (this.options.invisibleOverlay) {
                this.$el.addClass("transparent");
            }

            return this;
        },

        _activateHandler() {
            this.model.set("state", ShareState.HOVER_BEFORE_SHARING);
        }

    }, {

        instance: null,

        show(options) {
            const overlayView = new OverlayView(options);
            overlayView.render().$el.appendTo(window.document.body);

            OverlayView.instance = overlayView;
        },

        remove() {
            if (OverlayView.instance) {
                OverlayView.instance.remove();
                OverlayView.instance = null;
            }
        }
    });

    /**
     * The share button view.
     *
     * @author Bruce Mackenzie Nielsen
     * @class ShareButton
     *
     * @cfg {Object} [offset] The offset settings for the tooltip. Defaults to display in the middle.
     */
    return ImprovedView.extend({

        initialize() {
            this.model = new ShareViewModel({
                route: this.options.route,
                experience: this.options.experience
            });
        },

        template: () => "",

        className: "share-button-inner",

        events: {
            "activate": "_activateHandler"
        },

        modelEvents: {
            "change:state": "_updateTooltip"
        },

        _overlay: null,

        _activateHandler(event) {
            event.preventDefault();
            const state = this.model.get("state") === ShareState.PICKING_RECIPIENT ?
                ShareState.HOVER_BEFORE_SHARING : ShareState.PICKING_RECIPIENT;
            // If a share is in progress, cancel it, otherwise start a share
            this.model.set({state});
        },

        _updateTooltip() {
            let settings = {
                width: 170,
                // NOTE: Using tooltip `animation` (fade transition) with the current version (3.3.7) of
                // Bootstrap - will throw an error due to the below usage of the tooltip.
                animation: false,
                trigger: "manual",
                duration: 0,
                classes: ""
            };
            const element = this.options.tooltipContainer || this.$el;

            if (this.options.offset) {
                settings.offset = this.options.offset;
            }

            if (this.options.modal) {
                settings.classes += " modal-popover";
            }

            // Remove any existing tooltip and overlay
            Tooltip.remove(element);
            OverlayView.remove();

            // Add the appropriate tooltip
            switch (this.model.get("state")) {
                case ShareState.HOVER_BEFORE_SHARING:
                    if (!this.options.hideTooltip) {
                        settings.width = 150;
                        settings.content = "Share this experience with a colleague";
                        settings.trigger = "hover";
                        settings = _.extend(this.options.tooltipConfig || {}, settings);
                        Tooltip.add(element, settings);
                    }
                    break;

                case ShareState.PICKING_RECIPIENT:
                    this._trackOpenShareMenu();

                    settings.width = 208;
                    settings.classes += " share-menu-container";
                    settings.content = new ShareMenu({model: this.model});
                    settings.html = true;
                    Tooltip.add(element, settings);
                    Tooltip.show(element);

                    OverlayView.show({model: this.model, invisibleOverlay: this.options.invisibleOverlay});

                    break;

                case ShareState.AFTER_SHARING:
                    settings.content = "Thanks for sharing!";
                    Tooltip.add(element, settings);
                    Tooltip.show(element);

                    // Auto-hide the tooltip after 3 seconds, unless the state has changed in the meantime
                    _.delay(() => {
                        if (this.model.get("state") === ShareState.AFTER_SHARING) {
                            this.model.set("state", ShareState.HOVER_BEFORE_SHARING);
                        }
                    }, 3000);
                    break;

                default: // No need to log here.
                    break;
            }
        },

        onRender() {
            this._updateTooltip();
        },

        onClose() {
            Tooltip.remove(this.$el);
            OverlayView.remove();
        },

        _trackOpenShareMenu() {
            const {experience} = this.options;
            const eventProperties = {
                experienceId: experience.get("id"),
                experienceVersion: experience.get("version"),
                experiencePushedVersion: experience.get("pushedVersion"),
                triggerOrigin: "EditorMenu"
            };

            EditorEvents.trigger(EditorEvents.constants.OPEN_SHARE_MENU, eventProperties);
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/share/ShareButton.js